import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown'
import { CtfRichText, type ContentfulRichTextInterface } from './ctf-rich-text'

export type CtfMarkdownAllowedInstrinsicElements = 'div' | 'fragment'

export type ContentfulMarkdownTextInterface = {
  markdown: string
  as?: CtfMarkdownAllowedInstrinsicElements
} & Omit<ContentfulRichTextInterface, 'json'>

export const CtfMarkdownText = async (
  props: ContentfulMarkdownTextInterface,
) => {
  const { markdown, styling = 'margins-only' } = props
  const document = await richTextFromMarkdown(markdown)
  return <CtfRichText {...props} styling={styling} json={document} />
}
